import React, { useEffect, useMemo, useState } from "react";
import { Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "../../utils/adminApi";
import "./RFQ.css";

const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString();
};

const RFQ = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const [deletingId, setDeletingId] = useState("");

  const fetchRFQ = async () => {
    try {
      setLoading(true);
      setError("");
      const response = await adminApi.get("/api/contact");

      const payload = response.data;
      const normalizedItems = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.requests)
        ? payload.requests
        : [];

      setItems(normalizedItems);
    } catch (err) {
      setError(err.response?.data?.error || "Unable to load RFQ data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRFQ();
  }, []);

  const handleDelete = async (id) => {
    if (!id) return;
    if (!window.confirm("Delete this RFQ request?")) return;

    try {
      setDeletingId(String(id));
      await adminApi.delete(`/api/contact/${id}`);
      setItems((prev) =>
        prev.filter((item) => String(item._id) !== String(id))
      );
    } catch (err) {
      setError(err.response?.data?.error || "Delete failed.");
    } finally {
      setDeletingId("");
    }
  };

  const filteredItems = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;

    return items.filter((item) =>
      [
        item?.name,
        item?.email,
        item?.phone,
        // item?.address,
        item?.brand,
        item?.model,
        item?.issue,
        item?.message,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .includes(q)
    );
  }, [items, query]);

  return (
    <div className="rfq-page">
      {/* HEADER */}
      <div className="rfq-header">
        <div>
          <h1>RFQ Requests</h1>
          <p>All contact and quote requests from website.</p>
        </div>
      </div>

      {/* CARD */}
      <div className="rfq-card">
        {/* SEARCH */}
       <div className="rfq-search">
  <div className="rfq-input-wrapper">
    <input
      type="text"
      value={query}
      onChange={(e) => setQuery(e.target.value)}
    />
    {!query && (
      <span className="rfq-placeholder">
        Search by name, phone, email, brand...
      </span>
    )}
  </div>
</div>

        {/* STATES */}
        {error && <p className="rfq-feedback error">{error}</p>}
        {loading && <p className="rfq-feedback">Loading...</p>}

        {/* TABLE */}
        <div className="rfq-table-wrap">
          <table className="rfq-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                {/* <th>Address</th> */}
                <th>Brand</th>
                <th>Model</th>
                <th>Issue</th>
                <th>Message</th>
                <th>Created</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredItems.length > 0 ? (
                filteredItems.map((item) => (
                  <tr key={item._id}>
                    <td data-label="Name">{item.name || "-"}</td>
                    <td data-label="Email">{item.email || "-"}</td>
                    <td data-label="Phone">{item.phone || "-"}</td>
                    {/* <td data-label="Address">{item.address || "-"}</td> */}
                    <td data-label="Brand">{item.brand || "-"}</td>
                    <td data-label="Model">{item.model || "-"}</td>
                    <td data-label="Issue">{item.issue || "-"}</td>

                    <td data-label="Message">
                      <div className="rfq-message">
                        {item.message || "-"}
                      </div>
                    </td>

                    <td data-label="Created">
                      {formatDateTime(item.createdAt)}
                    </td>

                    <td data-label="Action">
                      <div className="rfq-actions">
                        <button
                          className="rfq-delete-btn"
                          onClick={() => handleDelete(item._id)}
                          disabled={deletingId === String(item._id)}
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="rfq-empty">
                    No RFQ requests found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RFQ;